import { createContext } from 'react';

export const AgencyContext = createContext();
